export const RequestNewTemplateModalId: string = 'RequestNewTemplateModal';
